import { render, staticRenderFns } from "./UserRoleBtns.vue?vue&type=template&id=2b612b2d&"
import script from "./UserRoleBtns.vue?vue&type=script&lang=js&"
export * from "./UserRoleBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports